import type { Xinglet } from '@xing-com/crate-xinglet';

import { Container } from './container';

export default class Search implements Xinglet {
  public getComponent(): React.FC {
    return Container;
  }
}
